import client from '../../providers/fetchClient'

export const getAllMartialTypes = () => client.get('/v3/marital-types')
